import { useQuery } from '@tanstack/react-query';
import { getOrderSource, orderSourcesQueryKeys } from '@api/orderSources';
import { ApiError } from '@api/client';
import type { OrderSourceShowResponse } from '@api/orderSources';

const STALE_TIME = 30_000;

interface UseOrderSourceOptions {
  initialData?: OrderSourceShowResponse;
}

/**
 * Mirrors `useResaleItem` — server-rendered Phlex first-paint props are
 * passed in as `initialData`; React Query keeps the record fresh after
 * edits, status toggles, and back-navigation.
 */
export function useOrderSource(id: number, { initialData }: UseOrderSourceOptions = {}) {
  return useQuery({
    queryKey: orderSourcesQueryKeys.detail(id),
    queryFn: () => getOrderSource(id),
    staleTime: STALE_TIME,
    select: (data) => data.order_source,
    retry: (failureCount, error) => {
      if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
        return false;
      }
      return failureCount < 3;
    },
    ...(initialData ? { initialData, initialDataUpdatedAt: Date.now() } : {}),
  });
}
